import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ALLOW_ANONYMOUS } from '@delon/auth';
import { Observable, from, forkJoin } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { SystemConfigService } from './system-config.service';

// Instagram API with Instagram Login 相关接口
export interface InstagramUser {
  id: string;
  name: string;
  userName?: string;
  profile_picture_url?: string;
  accessToken: string;
}

export interface InstagramMedia {
  id: string;
  media_type: 'IMAGE' | 'VIDEO' | 'CAROUSEL_ALBUM';
  media_url: string;
  permalink: string;
  caption?: string;
  timestamp: string;
  like_count?: number;
  comments_count?: number;
  thumbnail_url?: string;
}

export interface InstagramAuthResponse {
  access_token: string;
  user_id: string;
}

@Injectable({
  providedIn: 'root'
})
export class InstagramService {
  private readonly INSTAGRAM_API_BASE_URL = 'https://graph.instagram.com';
  private readonly INSTAGRAM_OAUTH_BASE_URL = 'https://www.instagram.com/oauth/authorize';
  private readonly INSTAGRAM_TOKEN_URL = 'https://api.instagram.com/oauth/access_token';
  private readonly http = inject(HttpClient);
  private readonly systemConfigService = inject(SystemConfigService);

  /**
   * 生成 Instagram OAuth URL
   * @param redirectUri 重定向URI
   * @param scope 权限范围
   * @param state 状态参数
   * @returns Observable<string> OAuth URL
   */
  generateInstagramOAuthUrl(
    redirectUri: string,
    scope: string[] = [
      'instagram_business_basic',
      'instagram_business_manage_messages',
      'instagram_business_manage_comments',
      'instagram_business_content_publish'
    ],
    state: string = ''
  ): Observable<string> {
    return this.systemConfigService.getInstagramAppId().pipe(
      map(clientId => {
        const scopeString = scope.join(',');

        const instagramAuthUrl =
          `${this.INSTAGRAM_OAUTH_BASE_URL}` +
          `?client_id=${clientId}` +
          `&redirect_uri=${encodeURIComponent(redirectUri)}` +
          `&scope=${encodeURIComponent(scopeString)}` +
          `&response_type=code`;

        if (state) {
          return `${instagramAuthUrl}&state=${encodeURIComponent(state)}`;
        }

        return instagramAuthUrl;
      })
    );
  }
}
